import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_support/transport")({
  beforeLoad: ({ context }) => guardRoute(context.me, "transport"),
  component: Outlet,
});
